import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Copy, ShieldCheck } from "@phosphor-icons/react";
import api from "@/lib/api";
import OneKiteQR from "@/components/OneKiteQR";

export default function QRScreen() {
  const [d, setD] = useState(null);

  useEffect(() => {
    api.get("/customer/qr").then((r) => setD(r.data)).catch(() => {});
  }, []);

  if (!d) return <div className="pt-10 text-center text-muted-foreground">Loading…</div>;

  return (
    <div className="pt-6 flex flex-col items-center text-center">
      <h1 className="font-display font-bold text-2xl mb-1">Your OneKite QR</h1>
      <p className="text-sm text-muted-foreground mb-8 max-w-xs">Show this to any merchant to earn and redeem points. It carries no personal data or balances.</p>

      <div className="fade-up" data-testid="customer-qr">
        <OneKiteQR value={d.qr_token} size={240} />
      </div>

      <p className="font-display font-bold text-xl mt-6" data-testid="qr-customer-name">{d.name}</p>
      {d.onekite_name && <p className="text-primary text-sm" data-testid="qr-onekite-name">@{d.onekite_name}</p>}
      <p className="font-mono text-sm text-muted-foreground tabular-nums mt-0.5" data-testid="qr-onekite-id">{d.onekite_id_formatted || d.onekite_id}</p>

      <button
        data-testid="copy-qr-token"
        onClick={() => { navigator.clipboard?.writeText(d.qr_token); toast.success("QR token copied"); }}
        className="mt-6 flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground rounded-full border border-black/10 px-4 py-2">
        <Copy size={16} /> Copy token (for staff scan testing)
      </button>

      <div className="mt-8 flex items-center gap-2 text-xs text-muted-foreground">
        <ShieldCheck size={16} className="text-primary" /> Secured with a signed identity token
      </div>
    </div>
  );
}
